// 네이버 지도 JS SDK 동적 로더 (현장 등록/수정 지도 핀 단계에서 사용)
// 키는 대장님이 별도 제공 → env VITE_NAVER_MAP_CLIENT_ID 로 주입.
// 신규(네이버 클라우드) 키는 ncpKeyId, 구(레거시) 키는 ncpClientId 를 사용한다.
// 제공 키가 레거시면 NCP_PARAM 만 'ncpClientId' 로 교체하면 된다.
const NCP_PARAM = 'ncpKeyId';

// ── SDK에서 사용하는 최소 타입 정의 (@types 미설치) ────────────────────────────
export interface NaverLatLng {
  lat(): number;
  lng(): number;
}

export interface NaverMap {
  getCenter(): NaverLatLng;
  setCenter(latlng: NaverLatLng): void;
  destroy?(): void;
}

interface NaverMapsNS {
  Map: new (el: HTMLElement, opts: Record<string, unknown>) => NaverMap;
  LatLng: new (lat: number, lng: number) => NaverLatLng;
  Event: { addListener(target: unknown, type: string, handler: () => void): unknown };
}

declare global {
  interface Window {
    naver?: { maps: NaverMapsNS };
  }
}

let loadPromise: Promise<void> | null = null;

/** 네이버 지도 SDK 를 1회 로드 (이미 로드되어 있으면 즉시 resolve) */
export function loadNaverMaps(clientId: string): Promise<void> {
  if (window.naver?.maps) return Promise.resolve();
  if (loadPromise) return loadPromise;

  loadPromise = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `https://oapi.map.naver.com/openapi/v3/maps.js?${NCP_PARAM}=${encodeURIComponent(clientId)}`;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => {
      loadPromise = null; // 재시도 가능하도록 초기화
      reject(new Error('네이버 지도 SDK 로드에 실패했습니다. 키(도메인 등록) 설정을 확인해주세요.'));
    };
    document.head.appendChild(script);
  });

  return loadPromise;
}
